import { SelectOption } from "components/atoms/Select";
export { default } from "./Header";

export interface ILink {
  to: string;
  text: string;
  active: string;
  options?: SelectOption[];
}
export interface DropDown {
  to: string;
  text: string;
}

export const fleetList: DropDown[] = [
  { text: "Vehicles", to: "/vehicles" },
  { text: "Car Movement", to: "/car-movement" },
  { text: "Availability", to: "/availability" },
  { text: "Models", to: "/models" },
  { text: "Class", to: "/class" },
  { text: "Zone", to: "/Zone" },
  { text: "Fuels", to: "/fuels" },
  { text: "Traffic Violations", to: "/traffic-violations" },
];

export const usersList: DropDown[] = [
  { text: "Users", to: "/users" },
  { text: "Roles", to: "/roles" },
  { text: "Chauffeurs", to: "/chauffeurs" },
  { text: "Partners", to: "/partners" },
  { text: "Companies", to: "/companies" },
];

export const invoiceList: DropDown[] = [
  { text: "Customer Invoices", to: "/customer-invoices" },
  { text: "Company Invoices", to: "/company-invoices" },
  { text: "Partner Invoices", to: "/partner-invoices" },
];

export const financeList: DropDown[] = [
  { text: "Pricing", to: "/pricing" },
  { text: "Pricing Engine", to: "/pricing-engine" },
  { text: "Location Prices", to: "/location-prices" },
  { text: "Special Prices", to: "/special-prices" },
  { text: "Commission", to: "/commission" },
  { text: "Payment Link", to: "/payment-link" },
];

export const supportList: DropDown[] = [
  { text: "Support", to: "/contacts" },
  { text: "Reported Problems", to: "/reported-problems" },
  { text: "Notifications", to: "/Notifications" },
  { text: "Search History", to: "/search-history" },
  { text: "Booking Ratings", to: "/booking-ratings" },
  { text: "Event Requests", to: "/events" },
  { text: "Partner Requests", to: "/partner-requests" },
  { text: "Company Requests", to: "/company-requests" },
];

export const eventsList: DropDown[] = [
  // { text: "Events", to: "/events" },
  { text: "Campaigns", to: "/campaigns" },
];

export const systemList: DropDown[] = [
	{ text: "Dynamics", to: "/dynamics" },
	{ text: "Asset Management", to: "/asset-management" },
	{ text: "Quotations", to: "/rfqs" },
	{ text: "Digital Contracts", to: "/digital-contracts" },
];

export const accountList: DropDown[] = [
  { text: "Profile", to: "/profile" },
  { text: "Logout", to: "/logout" },
];

export const deliveryList: DropDown[] = [
  { text: "Bookings", to: "/delivery-bookings" },
  { text: "Cars", to: "/delivery-cars" },
  { text: "Categories", to: "/delivery-car-categories" },
  { text: "Extras", to: "/delivery-car-extras" },
  { text: "Insurance", to: "/delivery-car-insurances" },
  { text: "Branches", to: "/delivery-branches" },
];
